import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="container-fluid">
      <div className="row footer-container-top">
        <div className="col-md-12">
          <div className="social" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ display: "flex", justifyContent: "center", width: '' }}>
              <ul class="menu" data-animation="to-top" style={{paddingLeft: "0px"}}>
                <li>
                  <a href="https://github.com/jahid777" target="blank" class="bg1">
                    <span>
                      <i class="bi bi-github"></i>
                    </span>
                    <span class="bg2">
                      <i class="bi bi-github" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>

              <ul class="menu" data-animation="to-top">
                <li>
                  <a href="https://www.linkedin.com/in/md-jahidul-islam-9578941a6" target="blank" class="bg1">
                    <span>
                      <i class="bi bi-linkedin"></i>
                    </span>
                    <span class="bg2">
                      <i class="bi bi-linkedin" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>

              <ul class="menu" data-animation="to-top">
                <li>
                  <a href="mailto:za0162hid@gmail.com" target="blank" class="bg1">
                    <span>
                      <i class="bi bi-envelope"></i>
                    </span>
                    <span class="bg2">
                      <i class="bi bi-envelope" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>

            </div>
          </div>

          <p className="copyright">
            &copy;Copyright 2026 Md Jahidul Islam Developed by{" "}
            <a title="Jahidul Islam" href="/about">
              Md Jahidul Islam
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
